export const ENGLISH = 'english';

export default {
  ENGLISH,
};
